<template>
  <LoyaltyHero heading="MEMBERS ONLY">
    <p>
      Welcome to our loyalty programme: your access-all-areas pass to all things
      Rat & Boa. Create an account now and you'll step into our V.I.P. world of
      unique rewards and bespoke benefits. Membership earns you early access to
      sales and new collections, vouchers, exclusive gifts and more - and we'll
      give you {{ signupBonus }} to spend on your first order.
    </p>
  </LoyaltyHero>

  <LoyaltyBenefitIcons />
  <LoyaltyRewardLevels />

  <LoyaltyHelp heading="NEED HELP?">
    <p>
      Click below for more details on making the most of our Members Only
      programme - or, if you’re a Level 3 or 4 member, you can speak to one of
      our team directly by using our exclusive concierge service.
    </p>
  </LoyaltyHelp>

  <Picture :images="images" />
</template>

<script>
import LoyaltyHero from "@/components/loyalty/LoyaltyHero.vue";
import LoyaltyHelp from "@/components/loyalty/LoyaltyHelp.vue";
import LoyaltyBenefitIcons from "@/components/loyalty/LoyaltyBenefitIcons.vue";
import LoyaltyRewardLevels from "@/components/loyalty/LoyaltyRewardLevels.vue";
import Picture from "@/components/Picture.vue";
import { signUpBonus } from "@/config";
import { mapGetters } from "vuex";

export default {
  name: "Loyalty",
  components: {
    LoyaltyHero,
    LoyaltyBenefitIcons,
    LoyaltyRewardLevels,
    LoyaltyHelp,
    Picture,
  },
  data() {
    return {
      images: {},
    };
  },
  computed: {
    ...mapGetters("app", ["currencyCode"]),
    signupBonus() {
      if (!this.currencyCode) {
        return null;
      }

      const amount = signUpBonus[this.currencyCode];
      return this.$filters.toCurrency(amount, this.currencyCode, 0);
    },
  },
  mounted() {
    const smallMedia = require("@/assets/images/loyalty/footer-large.jpg");
    const mediumMedia = require("@/assets/images/loyalty/footer-large.jpg");
    const largeMedia = require("@/assets/images/loyalty/footer-large.jpg");

    this.images = {
      smallMedia,
      mediumMedia,
      largeMedia,
    };
  },
};
</script>
